import React from 'react';
import * as Scroll from 'react-scroll';
import Image from 'next/image';
import { Accordion } from 'components/accordion';
import { ToggleCard, ToggleCardHeader, ToggleCardContent } from 'components/toggle-card';
import { Columns, ColumnsItem } from 'components/columns';
import { P1 } from 'components/typography';
import lexemes from 'components/lexemes';
import useWindowSize from 'lib/use-window-resize';
import { ToolsItemProps } from './tools-item.type';
// import { useRouter } from 'next/router';

const onClickHandler = () => {
    if (!CSS.supports('scroll-margin-top', 'calc(var(--header-height) + 8px)')) {
        setTimeout(() => {
            const scrollValue =
                parseInt(
                    getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
                    10
                ) || 58;
            Scroll.animateScroll.scrollMore(-1 * scrollValue, {
                delay: 0,
                smooth: false,
                duration: 0,
            });
        }, 100);
    }
};

const ToolsItem: React.FC<ToolsItemProps> = ({
    id,
    questionUrl,
    question,
    answer,
    imageUrl,
    imageWidth,
    imageHeight,
    index,
    activeEventKey,
    onCloseHandler,
    contentId,
}) => {
    const cardRef = React.useRef<HTMLDivElement>(null);
    // const router = useRouter();
    const [mobileMode, setMobileMode] = React.useState<boolean | undefined>(undefined);

    const size = useWindowSize();

    React.useEffect(() => {
        setMobileMode(Boolean(size?.width && size.width < 640));
    }, [size]);

    const ctaBlock = mobileMode ? (
        <button
            className="toggle-card-content__close-cta"
            onClick={() => {
                if (onCloseHandler) {
                    onCloseHandler();
                }

                const scrollValue =
                    parseInt(
                        getComputedStyle(document.documentElement).getPropertyValue(
                            '--header-height'
                        ),
                        10
                    ) || 58;
                Scroll.scroller.scrollTo(`${id}`, {
                    delay: 0,
                    smooth: false,
                    duration: 0,
                    offset: -1 * scrollValue,
                });
            }}
            aria-controls={contentId}
        >
            {lexemes.tools.lxBlockMobileCloseCta()}
        </button>
    ) : null;

    const mobileCtaBlock = mobileMode ? (
        <ColumnsItem size={ColumnsItem.size['1/2']} center={true}>
            <div className="toggle-card-content__media">{ctaBlock}</div>
        </ColumnsItem>
    ) : null;

    const isActive = activeEventKey === index;

    React.useEffect(() => {
        if (isActive) {
            // @TODO: add condition when page loaded?
            setTimeout(() => {
                onClickHandler();
            }, 200);
        }
    }, [isActive]);

    return (
        <ToggleCard isActive={isActive} id={questionUrl}>
            {/* @ts-ignore */}
            <Scroll.Element name={`${id}`}>
                <div ref={cardRef} />
            </Scroll.Element>
            <Accordion.Toggle
                element={ToggleCardHeader}
                eventKey={index}
                isActive={isActive}
                hasCloseActionIcon={true}
                onClick={() => {
                    onClickHandler();

                    // if (questionUrl) {
                    //     router.push(questionUrl);
                    // }
                }}
                contentId={contentId}
                tag="h3"
            >
                {question}
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={index} element={ToggleCardContent} contentId={contentId}>
                <Columns hasMobileLayout={true} vAlignTop={true}>
                    <ColumnsItem
                        size={imageUrl ? ColumnsItem.size['1/2'] : ColumnsItem.size['1/1']}
                    >
                        <P1 color="var(--color-primary-01)" html={answer} />
                    </ColumnsItem>
                    {imageUrl ? (
                        <ColumnsItem size={ColumnsItem.size['1/2']} center={true}>
                            <div className="toggle-card-content__media">
                                <Image
                                    // eslint-disable-next-line react/forbid-component-props
                                    className="toggle-card-content__image"
                                    src={imageUrl}
                                    alt=""
                                    width={imageWidth || 623}
                                    height={imageHeight || 1184}
                                    objectFit="contain"
                                />
                                {ctaBlock}
                            </div>
                        </ColumnsItem>
                    ) : (
                        mobileCtaBlock
                    )}
                </Columns>
            </Accordion.Collapse>
        </ToggleCard>
    );
};

export default ToolsItem;
